import React from 'react'
import { useTranslation } from 'react-i18next'

import RadioBlock from '../../../../../../components/Form/RadioBlock'
import AdQuarantineField from '../../../../../ReusableFormFields/AdQuarantineField'

import { STATUS } from '../../../fields'

import useStyles from '../../../../../../styles/common/stepForms'

const StatusStep = ({ formik }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { values, setFieldValue } = formik

  return (
    <>
      <div className={classes.stepTitle}>{t('Do you want the ad to go live immediately?')}</div>
      <div className={classes.stepBody}>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_status_paused"
          name={STATUS}
          label={t('No, set it as paused')}
          value="paused"
          selectedValue={values[STATUS]}
        >
          <p>{t('Your ad will not go live until you activate it later.')}</p>
        </RadioBlock>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_status_active"
          name={STATUS}
          label={t('Yes, set it as active')}
          value="active"
          selectedValue={values[STATUS]}
        >
          <p>{t('Your ad will go live immediately upon ad approval.')}</p>
        </RadioBlock>
        <AdQuarantineField formik={formik} />
      </div>
    </>
  )
}

export default StatusStep
